import styled from 'styled-components'

export const LineDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const LineLabelsWrapper = styled.div`
  padding: 0 1.2rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  * {
    font-size: 1.4rem;
  }
`
